export default "__VITE_ASSET__BNhLY5XC__"